import { createAsyncThunk } from '@reduxjs/toolkit';
import factoryOptionsApi from '../../../api/factoryOptionsApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'factoryOptions';

export const CreateFactoryOption = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/createFactoryOption`,
  async (data, thunkAPI) => {
    const res = await factoryOptionsApi.create(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetFactoryOptions = createAsyncThunk(`${REDUCER_NAME}/getFactoryOptions`, async (__, thunkAPI) => {
  const res = await factoryOptionsApi.get();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const GetFactoryOptionById = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/getFactoryOptionById`,
  async (id, thunkAPI) => {
    const res = await factoryOptionsApi.getById(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateFactoryOption = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateFactoryOption`,
  async ({ data, id }, thunkAPI) => {
    const res = await factoryOptionsApi.update(data, id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateInactive = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateInactive`,
  async ({ newInactive, id }, thunkAPI) => {
    const res = await factoryOptionsApi.updateInactive(newInactive, id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const ImportFactoryOptions = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/importFactoryOptions`,
  async (data, thunkAPI) => {
    const res = await factoryOptionsApi.import(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const DeleteFactoryOption = createAsyncThunk<{ id: string }, any>(
  `${REDUCER_NAME}/deleteFactoryOption`,
  async (id, thunkAPI) => {
    const res = await factoryOptionsApi.delete(id);

    if (res?.status === 200) {
      return { id };
    }

    return thunkAPI.rejectWithValue(null);
  }
);
